export const sessionData = "sessionData"
